import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatagridActionHandler } from '@core-lib/classes';
import { IDatagridSettings, IList } from '@core-lib/models';

@Component({
    selector: 'datagrid-paging',
    templateUrl: './datagrid-paging.component.html',
    standalone: false
})
export class DatagridPagingComponent<Item, SortableCols> {
	@Input() datagridHandler: DatagridActionHandler<SortableCols>;
	@Input() list: IList<Item>;
	@Input() settings: IDatagridSettings<SortableCols>;
	@Input() classList: string;
	@Input() withNewParam: boolean = false;
	@Input() attributeId: string = '';

	@Output() changePagingParam: EventEmitter<any> = new EventEmitter();

	onPageNumberChange(pageNumber: number): void {
		if (this.settings.pageNumber !== pageNumber) {
			if (!this.withNewParam) {
				this.datagridHandler.setPageNumber(pageNumber);
			} else {
				const settings: IDatagridSettings<SortableCols> = {
					options: this.settings.options,
					pageNumber: pageNumber,
					pageSize: this.settings.pageSize,
					sort: this.settings.sort,
					name: this.settings.name
				};
				this.changePagingParam.emit(settings);
			}
		}
	}

	onPageSizeChange(pageSize: number): void {
		if (this.settings.pageSize !== pageSize) {
			if (!this.withNewParam) {
				this.datagridHandler.setPageSize(pageSize);
			} else {
				const settings: IDatagridSettings<SortableCols> = {
					options: this.settings.options,
					pageNumber: 1,
					pageSize: pageSize,
					sort: this.settings.sort,
					name: this.settings.name
				};
				this.changePagingParam.emit(settings);
			}
		}
	}
}
